module.exports = __webpack_public_path__ + "static/img/apply-success.77a78ccd.png";